import styled from "styled-components";
import {SearchIconBoxDefault} from "./search-icon.default.box";
import {SearchInputFormBox} from "../search-input-form/search-input-form.box";

export const SearchIconWSOPBox = styled(SearchIconBoxDefault)`
    opacity: 0.5;
    
    ${SearchInputFormBox}:hover & {
        opacity: 1
    }
`;